import script from "./BusinessesForSupplierForecastTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessesForSupplierForecastTableCell.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessesForSupplierForecastTableCell.vue?vue&type=style&index=0&id=1e3439bc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3439bc"]])

export default __exports__